enum CommentType {
  RegLine = 0,
  Aberration = 1,
  Action = 2,
}

enum RegStatus {
  Open = 0,
  Started = 1,
  Done = 2,
  Closed = 3,
  Reopened = 4,
  Denied = 5,
  NotProcessed = 6,
  OneYearInspection = 7,
}

export { CommentType, RegStatus };
